module.exports = __webpack_public_path__ + "img/logo-white.b629d3a1.svg";